import * as pathToRegExp from 'path-to-regexp'
import { addDays } from 'tz-date-fns'
import { differenceInDays } from 'date-fns'
import { getFormattedDate } from '@shopping/common'

export * from './imageInspectionType'

export const HIGHEST_REVIEW_SCORE = 5
export const REVIEW_LIST_PAGE_SIZE = 20
export const BEST_REVIEW_LIST_PAGE_SIZE = 12
export const REVIEW_DIVIDE_FETCH_SIZE = 100
export const REVIEW_SUMMARY_PAGE_SIZE = 4
export const MIN_SUMMARY_REVIEW_SCORE = 4
export const MIN_SUMMARY_REVIEW_COUNT = 10
export const BEST_REVIEW_LIST_PC_CHUNK_SIZE = 2
export const MIN_EVALUATION_REVIEW_COUNT = 10
export const MIN_BEST_REVIEW_LIST = 3
export const MIN_PHOTO_VIDEO_LIST = 1
export const MAX_PHOTO_VIDEO_LIST = 500

export const NORMAL_REVIEW_PERIOD_END = 30
export const MONTH_REVIEW_PERIOD_END = 90
export const REWARDED_REVIEW_UNMODIFIABLE_END = 180
export const UNDELETABLE_END = 7

export namespace ReviewMessage {
  export const DELETE = '삭제된 리뷰입니다.'
  export const BLIND = '관리자에 의해 노출이 제한된 리뷰입니다.'
  export const NON_FIRST_WRITTEN_REVIEW = '처음에 작성한 리뷰가 조회되지 않습니다.'
  export const NON_REVIEW = '아직 작성된 리뷰가 없습니다.'
  export const NON_MATCHED_REVIEW = '조건에 맞는 리뷰가 없습니다.'
  export const RECOMMEND_WRITE_REVIEW = '이 상품을 구매하셨나요? 리뷰를 남겨주세요!'
  export const NOT_POSSIBLE_REVIEW = '리뷰를 사용하지 않는 상품입니다.'
}

export namespace ReviewPath {
  export const WRITE = '/(form|monthly-form)'
  export const MODIFY = '/:reviewId/update'
  export const BEST_PICKS = '/best-picks/:reviewId'
  export const PHOTO_VIDEOS = '/photo-videos/:reviewId'
  export const PHOTO_VIDEOS_LIST = '/photo-videos'
  export const REDIRECT = '/redirect'
  export const isModify = (pathname): boolean => {
    return pathToRegExp(ReviewPath.MODIFY).test(pathname)
  }
  export const isWrite = (pathname): boolean => {
    return pathToRegExp(ReviewPath.WRITE).test(pathname)
  }
}

export enum REVIEW_WINDOW_SIZE {
  WIDTH = 500,
  HEIGHT = 768,
}

export const isInUnmodifiablePeriodBecauseRewarded = (
  bestReview: boolean,
  benefitPaymentDate: number,
  today: number,
) => {
  const dueDateOfReviewUnmodifiable =
    benefitPaymentDate && addDays(benefitPaymentDate, REWARDED_REVIEW_UNMODIFIABLE_END)
  return {
    isUnmodifiable: Boolean(
      dueDateOfReviewUnmodifiable && differenceInDays(dueDateOfReviewUnmodifiable, today) >= 0 && bestReview,
    ),
    alertMessage: `스토어PICK 리뷰 혜택을 지급받은 리뷰는 선정일 이후 180일 이내 수정/삭제하실 수 없습니다.\n${getFormattedDate(
      dueDateOfReviewUnmodifiable,
      'YYYY.MM.DD',
    )}일 이후 수정 가능합니다.`,
  }
}

export const isReviewDeletable = (createDate: number, today: number) => {
  const dueDateOfReviewUndeletable = addDays(createDate, UNDELETABLE_END)
  return {
    isUndeletable: Boolean(dueDateOfReviewUndeletable && differenceInDays(dueDateOfReviewUndeletable, today) >= 0),
    alertMessage: `리뷰는 작성일 이후 7일 이내 삭제하실 수 없습니다.\n${getFormattedDate(
      dueDateOfReviewUndeletable,
      'YYYY.MM.DD',
    )}일 이후 삭제 가능합니다.`,
  }
}
